import { styled } from "styletron-react";

const LogoText = styled("span", ({ color }) => ({
  color,
  fontSize: "38px",
  fontWeight: "bold",
}));

export { LogoText };
